.card {
  display: flex;
  flex-direction: column;
  gap: var(--osp-space-4);
}

.choices {
  display: flex;
  flex-direction: column;
  gap: var(--osp-space-2);
  margin: 0;
  padding: 0;
  border: 0;
  min-width: 0;
}

.choice {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: var(--osp-space-1) var(--osp-space-3);
  align-items: start;
  padding: var(--osp-space-3) var(--osp-space-4);
  border: 1px solid var(--osp-border);
  border-radius: var(--osp-radius);
  background: var(--osp-surface);
  cursor: pointer;
}

.choice:has(input:checked) {
  border-color: var(--osp-accent);
  background: var(--osp-accent-soft);
}

.choice:has(input:focus-visible) {
  outline: 2px solid var(--osp-focus);
  outline-offset: 2px;
}

.choice input {
  margin-top: 3px;
  accent-color: var(--osp-accent);
}

.choiceTitle {
  font-weight: 600;
}

.choiceText {
  grid-column: 2;
  color: var(--osp-ink-muted);
  font-size: var(--osp-text-sm);
}

.preview {
  grid-column: 2;
  display: flex;
  flex-direction: column;
  gap: 2px;
  max-width: 340px;
  margin-top: var(--osp-space-1);
  padding: var(--osp-space-2) var(--osp-space-3);
  border-radius: 12px;
  background: var(--osp-surface-sunken);
  font-size: var(--osp-text-sm);
}

.previewTitle {
  font-weight: 620;
}

.previewBody {
  color: var(--osp-ink-muted);
}

.footer {
  display: flex;
  justify-content: flex-end;
  gap: var(--osp-space-2);
}

/* OSPattern support access: the grants given and who used them. */
.legend {
  margin-bottom: var(--osp-space-2);
  font-weight: 600;
}

.grants {
  display: flex;
  flex-direction: column;
  gap: var(--osp-space-3);
  margin: 0;
  padding: 0;
  list-style: none;
}

.grant {
  display: flex;
  flex-direction: column;
  gap: var(--osp-space-1);
  padding: var(--osp-space-3) var(--osp-space-4);
  border: 1px solid var(--osp-border);
  border-radius: var(--osp-radius);
}

.grantHead {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--osp-space-2);
}

.grantSessions {
  margin: 0;
  padding-left: var(--osp-space-5);
  font-size: var(--osp-text-sm);
}

.formGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: var(--osp-space-3) var(--osp-space-4);
}

.previewLine {
  margin: 0;
  color: var(--osp-ink-muted);
  font-size: var(--osp-text-sm);
}

.customRow {
  margin: 0;
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: var(--osp-space-2) var(--osp-space-3);
  align-items: end;
  padding: var(--osp-space-3);
  border: 1px solid var(--osp-border);
  border-radius: var(--osp-radius);
}

.customUses {
  margin: 0;
  color: var(--osp-ink-muted);
  font-size: var(--osp-text-sm);
}

.languageGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(14rem, 1fr));
  gap: var(--osp-space-2) var(--osp-space-4);
}
